import React, { useEffect, useState } from "react";
import { useLoader } from "../context/LoaderContext";
import { fetchListMemberBanner, fetchMemberLists } from "../api/MemberApi";
import { IBannerData, IMemberListData } from "../exports/interfaces";
import { dynamicFailed } from "../hooks/useToast";
import ListMemberBanner from "../components/listmember/ListMemberBanner";
import ListMemberTable from "../components/listmember/ListMemberTable";

const ListMember = () => {
  const { setLoading } = useLoader();
  const [listMemberBannerData, setListMemberBannerData] = useState<
    IBannerData[]
  >([]);
  const [listMemberData, setListMemberData] = useState<IMemberListData[]>([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchListMemberBanner(), fetchMemberLists()])
      .then(([listMemberBannerData, listMemberData]) => {
        setListMemberBannerData(listMemberBannerData);
        setListMemberData(listMemberData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [listMemberBannerData.length, setLoading]);
  return (
    <>
      <ListMemberBanner listMemberBannerData={listMemberBannerData} />
      <ListMemberTable listMemberData={listMemberData}/>
    </>
  );
};

export default ListMember;
